<template>
  <div>
    <!-- Full Leaf -->
    <svg
      v-if="type === 'full'"
      :width="size"
      :height="height"
      viewBox="0 0 17 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.847 9.308C1.473 4.186 6.287 1.393 15.289.93c1.524-.184 1.336.584 1.065 1.58-1.028 3.775-3.897 12.96-15.08 9.575C.891 11.04.75 10.115.846 9.308z"
        :fill="fgColourCode"
        fill-rule="evenodd"
      />
    </svg>

    <!-- Half Leaf -->
    <svg
      v-if="type === 'half'"
      :width="size"
      :height="height"
      viewBox="0 0 17 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="none"
        fill-rule="evenodd"
      >
        <path
          d="M8 2.07v10.524c-1.82.392-4.032.306-6.727-.51C.892 11.04.75 10.115.847 9.309c.428-3.5 2.812-5.913 7.152-7.238z"
          :fill="fgColourCode"
        />
        <path
          d="M16.354 2.51c-.78 2.865-2.621 8.848-8.354 10.084L7.998 2.07c2.01-.614 4.441-.994 7.291-1.141 1.524-.184 1.336.584 1.065 1.58z"
          :fill="bgColourCode"
        />
      </g>
    </svg>

    <!-- Empty Leaf -->
    <svg
      v-if="type === 'empty'"
      :width="size"
      :height="height"
      viewBox="0 0 17 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.847 8.836C1.473 3.714 6.287.92 15.289.457c1.524-.184 1.336.584 1.065 1.58-1.028 3.775-3.897 12.96-15.08 9.575C.891 10.567.75 9.642.846 8.836z"
        :fill="bgColourCode"
        fill-rule="evenodd"
      />
    </svg>
  </div>
</template>

<script lang="ts">

export default defineNuxtComponent({
  props: {
    size: { type: Number, default: () => 17 },
    // full, half, empty
    type: { type: String, default: () => 'full' },
    fgColour: { type: String, default: () => 'spl-primary' },
    bgColour: { type: String, default: () => 'spl-gray-1' },
  },
  setup(props) {
    const height = computed(() => props.size * (11 / 17))
    const fgColourCode = '#017074'
    const bgColourCode = '#eaeaea'

    return {
      height,
      fgColourCode,
      bgColourCode,
    }
  },
})
</script>
